import { ApolloError } from '@apollo/client';
import {
  getLandingPageErrorCode,
  LandingPageErrorCode,
} from 'src/graphql/error-codes/landing-page-error-codes';

const DEFAULT_LANDING_PAGE_ERROR = 'Failed to save the landing page.';

const MESSAGES: Record<LandingPageErrorCode, string> = {
  [LandingPageErrorCode.LANDING_PAGE_SLUG_INVALID]:
    'That URL slug is not valid. Use lowercase letters, numbers and single hyphens.',
  [LandingPageErrorCode.LANDING_PAGE_SLUG_TAKEN]:
    'That URL slug is already used by another landing page for this partner.',
  [LandingPageErrorCode.LANDING_PAGE_CONFIG_INVALID]:
    'The landing page content could not be saved because it is not valid.',
};

export function parseLandingPageError(error: ApolloError): string {
  for (const graphQLError of error.graphQLErrors) {
    const machineCode = getLandingPageErrorCode(graphQLError);

    if (machineCode) {
      return MESSAGES[machineCode];
    }
  }

  return DEFAULT_LANDING_PAGE_ERROR;
}
